import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  OnInit,
  NgZone,
} from '@angular/core';
import { RecaptchaService } from '../../services/recaptcha.service';

declare global {
  interface Window {
    turnstile: any;
  }
}

@Component({
  selector: 'app-turnstile',
  template: `<div class="cf-turnstile" id="cf-turnstile"></div>`,
})
export class TurnstileComponent implements OnInit {
  @Input() siteKey!: string;
  @Input() action = 'default';
  @Output() resolved = new EventEmitter<string>();

  constructor(
    private el: ElementRef,
    private zone: NgZone,
    private recaptchaService: RecaptchaService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.recaptchaService.iniciar();

    this.loadTurnstileScript().then(() => {
      window.turnstile.render('#cf-turnstile', {
        sitekey: this.siteKey,
         theme: 'light',
        callback: (token: string) => {
          this.zone.run(() => this.resolved.emit(token));
        },
        'expired-callback': () => {
          console.warn('Token expirado no componente');
        },
        'error-callback': (erro: any) => {
          console.error('Erro no componente Turnstile:', erro);
        },
      });
    });
  }

  private loadTurnstileScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const scriptId = 'cf-turnstile-script';
      if (document.getElementById(scriptId)) {
        return resolve();
      }

      const url = this.recaptchaService['configuracoes']?.URL_TURNSTILE_CLOUDFLARE;
      if (!url) {
        return reject('URL do script Turnstile não encontrada na configuração');
      }

      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.defer = true;
      script.id = scriptId;
      script.onload = () => resolve();
      script.onerror = () => reject('Erro ao carregar script Turnstile');
      document.head.appendChild(script);
    });
  }
}
